import {Component, ElementRef, HostBinding, OnInit, ViewChild} from '@angular/core';

import {TranslateService} from '@ngx-translate/core';

import {UserService} from 'app/profile';
import {LocalSettingsService} from 'shared/local-settings/local-settings.service';
import {NavService} from 'shared/nav/nav.service';

import { HyphenateService } from 'shared/helpers/hyphenate.service';
import { ActivatedRoute, ParamMap } from '@angular/router';
import { switchMap } from 'rxjs';

@Component({
  selector: 'mode-info-page',
  templateUrl: 'mode-info-page.html',
  styleUrls: ['mode-info-page.scss'],
})
export class ModeInfoPage implements OnInit {

  public mode: string = '';

  constructor(
    public navService: NavService,
    public userService: UserService,
    private activatedRoute: ActivatedRoute,
    private localSettingsService: LocalSettingsService,
  ) { }

  public ngOnInit() {
    this.activatedRoute.paramMap.subscribe((params) => {
        this.mode = params.get('mode');
        return this.mode;
      }
    );
  }

  public onUseModeClick(): void {
    this.localSettingsService.set(LocalSettingsService.MODE, this.mode)
      .then(() => {
        this.navService.root('/login');
      });
  }

  public get modeUC():string {
    return this.mode.toUpperCase();
  }

}
